import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { images } from '../../../Constants/ImageUrls';
import {
  browseAllCategoriesClickEvent,
  fireFilterServeEvent,
} from '../../../Utils/CategoryPageUtils';
import { removeDefaultParams } from '../../../Utils/helper';
import { BrowseRelatedCatSection, RelatedList, Title } from './styled';

export default function BrowseRelatedCategory(props) {
  const { categoryFilterData, category_name, title } = props;
  const router = useRouter();
  useEffect(() => {
    if (categoryFilterData?.length)
      fireFilterServeEvent(categoryFilterData, category_name);
  }, [categoryFilterData]);
  return categoryFilterData?.length ? (
    <BrowseRelatedCatSection>
      <Title>{title ? title : 'BROWSE RELATED CATEGORIES'}</Title>
      <RelatedList>
        {categoryFilterData?.map((element, index) => {
          return element?.tabName != 'All' ? (
            <Link
              href={{
                pathname: element?.webUrl || element?.web_url,
                query: removeDefaultParams(router.query),
              }}
              passHref
              locale={false}
            >
              <li
                onClick={() =>
                  browseAllCategoriesClickEvent(element, category_name)
                }
                id={`categoryBrowse_${index}`}
              >
                <span>{element?.tabName || element?.description}</span>
                <img
                  src={images.arrowDownForward}
                  alt="arrow"
                  className="arrow_forward"
                />
              </li>
            </Link>
          ) : null;
        })}
      </RelatedList>
    </BrowseRelatedCatSection>
  ) : null;
}
